<script setup>
const props = defineProps({
  divisions: {type: Array, default: () => []},
  compact: {type: Boolean, default: false},
});

// Compact style: top five rows, positions/names/total points only
const visibleRows = (division) =>
    props.compact ? (division.rows || []).slice(0, 5) : (division.rows || []);
</script>

<template>
  <div>
    <div v-if="!divisions.length" class="ws-empty">No standings to show yet.</div>
    <div v-for="(division, index) in divisions" :key="index" class="ws-division">
      <div v-if="divisions.length > 1 || division.name" class="ws-division-name">
        {{ division.name }}
        <span v-if="index === 0 && division.cycleName" class="ws-cycle">{{ division.cycleName }}</span>
      </div>
      <table class="ws-table">
        <thead>
        <tr>
          <th class="ws-pos">#</th>
          <th>{{ (division.playersPerTeam ?? 1) <= 1 ? 'Player' : 'Team' }}</th>
          <th v-if="!compact" class="ws-num">P</th>
          <th v-if="!compact" class="ws-num">BON</th>
          <th class="ws-num">PTS</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in visibleRows(division)" :key="row.position + row.teamName">
          <td class="ws-pos">
            <span class="ws-pos-badge" :class="{'ws-pos-top': row.position === 1}">{{ row.position }}</span>
          </td>
          <td class="ws-team">{{ row.teamName }}</td>
          <td v-if="!compact" class="ws-num">{{ row.played }}</td>
          <td v-if="!compact" class="ws-num">{{ row.bonusPoints }}</td>
          <td class="ws-num ws-points">{{ row.totalPoints }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use './widget-tables' as *;
</style>
